/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyOnAzure } from './EmergencyOnAzure';
import {
    EmergencyOnAzureFromJSON,
    EmergencyOnAzureFromJSONTyped,
    EmergencyOnAzureToJSON,
    EmergencyOnAzureToJSONTyped,
} from './EmergencyOnAzure';
import type { EmergencyMessageOnAzure } from './EmergencyMessageOnAzure';
import {
    EmergencyMessageOnAzureFromJSON,
    EmergencyMessageOnAzureFromJSONTyped,
    EmergencyMessageOnAzureToJSON,
    EmergencyMessageOnAzureToJSONTyped,
} from './EmergencyMessageOnAzure';
import type { UserLocationOnAzure } from './UserLocationOnAzure';
import {
    UserLocationOnAzureFromJSON,
    UserLocationOnAzureFromJSONTyped,
    UserLocationOnAzureToJSON,
    UserLocationOnAzureToJSONTyped,
} from './UserLocationOnAzure';

/**
 * 
 * @export
 * @interface EmergencyFullData
 */
export interface EmergencyFullData {
    /**
     * 
     * @type {EmergencyOnAzure}
     * @memberof EmergencyFullData
     */
    emergency: EmergencyOnAzure;
    /**
     * 
     * @type {Array<EmergencyMessageOnAzure>}
     * @memberof EmergencyFullData
     */
    emergency_messages: Array<EmergencyMessageOnAzure>;
    /**
     * 
     * @type {Array<UserLocationOnAzure>}
     * @memberof EmergencyFullData
     */
    locations: Array<UserLocationOnAzure>;
}

/**
 * Check if a given object implements the EmergencyFullData interface.
 */
export function instanceOfEmergencyFullData(value: object): value is EmergencyFullData {
    if (!('emergency' in value) || value['emergency'] === undefined) return false;
    if (!('emergency_messages' in value) || value['emergency_messages'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    return true;
}

export function EmergencyFullDataFromJSON(json: any): EmergencyFullData {
    return EmergencyFullDataFromJSONTyped(json, false);
}

export function EmergencyFullDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyFullData {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency': EmergencyOnAzureFromJSON(json['emergency']),
        'emergency_messages': ((json['emergency_messages'] as Array<any>).map(EmergencyMessageOnAzureFromJSON)),
        'locations': ((json['locations'] as Array<any>).map(UserLocationOnAzureFromJSON)),
    };
}

export function EmergencyFullDataToJSON(json: any): EmergencyFullData {
    return EmergencyFullDataToJSONTyped(json, false);
}

export function EmergencyFullDataToJSONTyped(value?: EmergencyFullData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency': EmergencyOnAzureToJSON(value['emergency']),
        'emergency_messages': ((value['emergency_messages'] as Array<any>).map(EmergencyMessageOnAzureToJSON)),
        'locations': ((value['locations'] as Array<any>).map(UserLocationOnAzureToJSON)),
    };
}

